import { ComposedTheme } from '@glu/theming';

/* istanbul ignore file */
export default ({ palette, typography }: ComposedTheme) => ({
  indicator: {
    // @theming labelText: Indicator Background Color, type: color
    backgroundColor: palette.colors.lime,
    // @theming labelText: Indicator Height, type: pixel
    height: 4,
    // @theming labelText: Indicator Transition Duration, type: string
    transitionDuration: 300,
    // @theming labelText: Indicator Transition, type: string
    transition: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  tab: {
    // @theming labelText: Text Color, type: color
    color: palette.primary.normal,
    // @theming labelText: Selected Tab Color, type: color
    selectedColor: palette.text.dark,
    // @theming labelText: Focus Outline Color, type: color
    focusColor: palette.focus.normal,
  },
  tabDark: {
    // @theming labelText: Dark Text Color, type: color
    color: palette.text.light,
    // @theming labelText: Dark Focus Color, type: color
    darkFocusColor: palette.focus.dark,
  },
  tabAddition: {
    // @theming labelText: Font, type: string
    font: `20px "Roboto Condensed", ${typography.fontFamily}`,
    // @theming labelText: Text Transform, type: string
    textTransform: 'uppercase',
  },
  wrapBorder: {
    // @theming labelText: Tabs Padding Top, type: pixel
    paddingTop: 10,
  },
  styledTab: {
    // @theming labelText: Styled Tab Background Color, type: color
    backgroundColor: palette.colors.gallery,
    // @theming labelText: Styled Tab Font Family, type: fontFamily
    fontFamily: `${typography.fontFamily}`,
    // @theming labelText: Styled Tab Bottom Border Color, type: string
    borderBottomColor: `${palette.grey.G400} !important`,
  },
  // @theming labelText: Styled Tab Border Color, type: color
  defaultTabBorderColor: palette.grey.G400,
  // Broken, solid should be removed and only a color should be applied - in GLU-7492
  // Reapply when above is fixed - labelText: Styled Tab Top Border Color, type: color
  defaultTabBorder: `solid ${palette.grey.G400}`,
  badge: {
    // @theming labelText: Badge Background Color, type: color
    backgroundColor: palette.colors.catskillWhite,
    // @theming labelText: Badge Text Color, type: color, backgroundColor: tabs.badge.backgroundColor
    color: palette.text.dark,
    // @theming labelText: Badge Padding, type: pixel
    padding: 5,
    // @theming labelText: Badge Minimum Width, type: pixel
    minWidth: 25,
    // @theming labelText: Badge Border Radius, type: pixel
    borderRadius: 20,
    // @theming labelText: Badge Display, type: string
    display: 'block',
    // @theming labelText: Badge Font Size, type: pixel
    fontSize: 12,
    // @theming labelText: Badge Font Weight, type: string
    fontWeight: 'bold',
  },
});
